import QuotationPdfService
    from "../../services/pdf/quotationPdf.service";

import useLoading from "../useLoading";

export const useQuotationPdf = () => {

    const {
        showLoadingIndicator,
        hideLoadingIndicator,
    } = useLoading();

    /**
     * 📄 Descargar PDF
     * de cotización
     */
    const handleDownloadQuotationPdf =
        async (
            quotationId: number
        ) => {

            try {

                showLoadingIndicator();

                const {
                    blob,
                    fileName,
                } =
                    await QuotationPdfService.download(
                        quotationId
                    );

                const url =
                    window.URL.createObjectURL(
                        blob
                    );

                const link =
                    document.createElement("a");

                link.href = url;

                link.download =
                    fileName ||
                    `cotizacion_${quotationId}.pdf`;

                document.body.appendChild(link);

                link.click();

                link.remove();

                window.URL.revokeObjectURL(url);

            } catch (error) {

                console.error(
                    "❌ Error descargando PDF de cotización:",
                    error
                );

            } finally {

                hideLoadingIndicator();

            }
        };

    return {
        handleDownloadQuotationPdf,
    };
};

export default useQuotationPdf;